import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  deleteEmailTemplate,
  emailTemplatesList,
  gotoUrl,
} from "../../actions";

export class DeleteEmailTemplateModal extends Component {
  constructor(props) {
    super(props);
    this.delete = this.delete.bind(this);
  }

  delete(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, emailTemplate } = this.props;

    this.props
      .deleteEmailTemplate(accountId, emailTemplate.id)
      .then(this.props.closeModal);
  }

  render() {
    const { emailTemplate } = this.props;
    const content = emailTemplate?.name
      ? `Remove ${emailTemplate.name}`
      : "Removing";

    return (
      <Modal>
        <ModalHeader>Delete Email?</ModalHeader>
        <ModalContent>{content}</ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.delete}>Delete</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

DeleteEmailTemplateModal.propTypes = {
  emailTemplate: PropTypes.object.isRequired,
  deleteEmailTemplate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const emailTemplate = state.entities.emailTemplate[id];

  return {
    accountId,
    id,
    emailTemplate,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  deleteEmailTemplate,
  emailTemplatesList,
  gotoUrl,
})(DeleteEmailTemplateModal);
